import { create } from "zustand";

/**
 * Per-annotation, per-element state that we want to preserve across re-renders, refetches,
 * and (eventually) virtualisation. Lives outside the DOM so it survives React unmount and
 * `dangerouslySetInnerHTML`-style innerHTML replacements.
 *
 * Currently models the `open` state of `<details>` elements. Other
 * browser-managed state (`<video currentTime>`, scroll position, text selection) can be
 * added here with the same shape if/when needed.
 */

type ElementKey = string;

interface AnnotationElementStateStore {
  detailsOpen: Record<ElementKey, boolean>;
  setDetailsOpen: (key: ElementKey, open: boolean) => void;
}

export function elementKey(annotationId: string, path: string): ElementKey {
  return `${annotationId}::${path}`;
}

export const useAnnotationElementStateStore = create<AnnotationElementStateStore>((set) => ({
  detailsOpen: {},

  setDetailsOpen: (key, open) =>
    set((state) => {
      if (state.detailsOpen[key] === open) {
        return state;
      }
      return { detailsOpen: { ...state.detailsOpen, [key]: open } };
    }),
}));
